import { QueryClientProvider } from "@tanstack/react-query"
import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { RouterProvider } from "react-router/dom"
import { SessionProvider } from "./auth/session"
import { queryClient } from "./lib/query"
import { router } from "./routes"
import { ThemeProvider } from "./theme/theme-provider"

// Punto de entrada de la consola: theming white-label (FluentProvider con temas
// propios) + cache de servidor + sesión + router.
const rootElement = document.getElementById("root")
if (rootElement) {
  createRoot(rootElement).render(
    <StrictMode>
      <ThemeProvider>
        <QueryClientProvider client={queryClient}>
          <SessionProvider>
            <RouterProvider router={router} />
          </SessionProvider>
        </QueryClientProvider>
      </ThemeProvider>
    </StrictMode>,
  )
}
